import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

//import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreCollection} from 'angularfire2/firestore';

import 'firebase/firestore';

//import firebase from 'firebase/app';
import { ContactItem } from '../../pages/contacts/contactitem';
import { DeliveryItem } from '../../pages/delivery/deliveryitem';
import { PickupItem } from '../../pages/pickup/pickupitem';
import { ProductionItem } from '../../pages/production/productionitem';
import { SMPItem } from '../../pages/smp/smpitem';
import { NotificationItem } from '../../pages/mill-manager/notificationitem';

/*
  Generated class for the DatabaseProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class DatabaseProvider {

  contactitems: Observable<ContactItem[]>;
  contactitemsCollection: AngularFirestoreCollection<ContactItem>;
  deliveryitems: Observable<DeliveryItem[]>;
  deliveryitemsCollection: AngularFirestoreCollection<DeliveryItem>;
  pickupitems: Observable<PickupItem[]>;
  pickupitemsCollection: AngularFirestoreCollection<PickupItem>;
  smpitems: Observable<SMPItem[]>;
  smpitemsCollection: AngularFirestoreCollection<SMPItem>;
  productionitems: Observable<ProductionItem[]>;
  productionitemsCollection: AngularFirestoreCollection<ProductionItem>;
  notificationitems: Observable<NotificationItem[]>;
  notificationitemsCollection: AngularFirestoreCollection<NotificationItem>;

  constructor(public db: AngularFirestore) {

    console.log('Hello DatabaseProvider AngularFirestore Provider');
    //db.firestore.enablePersistence();
    //console.log('Hello DatabaseProvider AngularFirestore enableDPersistence()');

    this.contactitemsCollection = this.db.collection('contact', ref => ref.orderBy('lastname', 'asc') );
    this.deliveryitemsCollection = this.db.collection('delivery', ref => ref.orderBy('date', 'desc') );
    this.pickupitemsCollection = this.db.collection('pickup');
    this.productionitemsCollection = this.db.collection('production', ref => ref.orderBy('date', 'desc') );
    this.smpitemsCollection = this.db.collection('smp');
    this.notificationitemsCollection = this.db.collection('notification');

    this.contactitems = this.contactitemsCollection.valueChanges();
    this.deliveryitems = this.deliveryitemsCollection.valueChanges();
    this.pickupitems = this.pickupitemsCollection.valueChanges();
    this.productionitems = this.productionitemsCollection.valueChanges();
    this.smpitems = this.smpitemsCollection.valueChanges();
    this.notificationitems = this.notificationitemsCollection.valueChanges();

  }

  saveContact(aContactItem : ContactItem) : Promise<any> {
    console.log('Database Provider saveContact(...)' + aContactItem.lastname);
    return this.contactitemsCollection.doc(aContactItem.id).set(aContactItem)
    .then( (result) => {
        console.log("aContactItem addded with id >>> ", aContactItem.id);
    })
    .catch( (error) => {
        console.error("Error adding aContactItem: ", error);
    });
  }

  removeContact(aContactItem : ContactItem) : Promise<any> {
    console.log('Database Provider removeContact(...)' + aContactItem.id);
    return this.contactitemsCollection.doc(aContactItem.id).delete();
  }

  saveDeliveryItem(aDeliveryItem : DeliveryItem) : Promise<any> {
    console.log('Database Provider saveDeliveryItem(...)' + aDeliveryItem);
    return this.deliveryitemsCollection.doc(aDeliveryItem.id).set(aDeliveryItem)
    .then( (result) => {
        console.log("aDeliveryItem addded with id >>> ", aDeliveryItem.id);
    })
    .catch( (error) => {
        console.error("Error adding aDeliveryItem: ", error);
    });
  }

  savePickupItem(aPickupItem : PickupItem) : Promise<any> {
    console.log('Database Provider savePickupItem(...)' + aPickupItem);
    return this.pickupitemsCollection.doc(aPickupItem.id).set(aPickupItem)
    .then( (result) => {
        console.log("aPickupItem addded with id >>> ", aPickupItem.id);
    })
    .catch( (error) => {
        console.error("Error adding aPickupItem: ", error);
    });
  }

  saveProductionItem(aProductionItem : ProductionItem) : Promise<any> {
    console.log('Database Provider saveProductionItem(...)' + aProductionItem);
    return this.productionitemsCollection.doc(aProductionItem.id).set(aProductionItem)
    .then( (result) => {
        console.log("aProductionItem addded with id >>> ", aProductionItem.id);
    })
    .catch( (error) => {
        console.error("Error adding aProductionItem: ", error);
    });
  }

  saveSMPItem(aSMPItem : SMPItem) : Promise<any> {
    console.log('Database Provider saveSMPItem(...)' + aSMPItem);
    return this.smpitemsCollection.doc(aSMPItem.id).set(aSMPItem)
    .then( (result) => {
        console.log("aSMPItem addded with id >>> ", aSMPItem.id);
    })
    .catch( (error) => {
        console.error("Error adding aSMPItem: ", error);
    });
  }

  markDeliveryItemAsPaid(aDeliveryItem: DeliveryItem){
    this.deliveryitemsCollection.doc(aDeliveryItem.id).update({paid: 'true'});
  }

  markPickupItemAsPaid(aPickupItem: PickupItem){
    this.pickupitemsCollection.doc(aPickupItem.id).update({paid: 'true'});
  }

  markNotificationItemAsDone(aNotificationItem: NotificationItem){
    this.notificationitemsCollection.doc(aNotificationItem.id).update({done: 'true'});
  }

  getContactListObservable(): Observable<ContactItem[]>{
    return this.contactitems;
  }

  getDeliveryListObservable(): Observable<DeliveryItem[]>{
    return this.deliveryitems;
  }

  getPickupListObservable(): Observable<PickupItem[]>{
    return this.pickupitems;
  }

  getProductionListObservable(): Observable<ProductionItem[]>{
    return this.productionitems;
  }

  getSMPListObservable(): Observable<SMPItem[]>{
    return this.smpitems;
  }

   getNotificationListObservable(): Observable<NotificationItem[]>{
    return this.notificationitems;
  }

  getDBId(){
    return this.db.createId();
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts